import React from 'react';
import {
  FaFacebook,
  FaInstagram,
  FaGlobe,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>SyarTech</h3>
            <p>Making car care convenient, reliable, and affordable for everyone.</p>
            <div className="social-links">
              <a
                href="https://www.facebook.com/profile.php?id=61584276933010"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook className="social-icon" />
              </a>
              <a
                href="https://www.instagram.com/car_washeg/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram className="social-icon" />
              </a>
              <a
                href="https://kamshka.com/contact"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaGlobe className="social-icon" />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <a href="#features">Features</a>
            <a href="#how-it-works">How It Works</a>
            <a href="#download">Download</a>
            {/* Updated Contact Us link */}
            <a 
              href="https://kamshka.com/contact" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Contact Us
            </a>
          </div>

          <div className="footer-section">
            <h4>Legal</h4>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/shipping">Shipping Policy</Link>
            <Link to="/refund">Refund Policy</Link>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>

            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <span>
                Sanad Workspace, Al Centeral Street, First Area,<br />
                6th October City, Egypt
              </span>
            </div>

            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <a href="tel:+201007745941">
                +20 100 774 5941
              </a>
            </div>

            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <a href="mailto:info@kamshka.com">
                info@kamshka.com
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; 2024 SyarTech. All rights reserved. | Making Egypt&apos;s cars shine!
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
